export default __webpack_public_path__ + "static/media/notif_close.6163971e.png";